import React, { useEffect, useState } from "react";
import api from "../../../api/axios";

export default function PayrollSettings() {
  const [activeTab, setActiveTab] = useState("payroll");

  // PAYROLL SETTINGS
  const [payCycle, setPayCycle] = useState("Monthly");
  const [payDay, setPayDay] = useState("28");

  // COMPANY PROFILE SETTINGS
  const [companyName, setCompanyName] = useState("Your Company LLC");
  const [address, setAddress] = useState("123 Main St, Anytown, USA");

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const res = await api.get("hrms/settings");
      // Example backend mapping ↓
      setPayCycle(res.data.pay_cycle);
      setPayDay(res.data.pay_day);
      setCompanyName(res.data.company_name);
      setAddress(res.data.company_address);
    } catch (err) {
      console.warn("API unavailable → using sample settings");
    }
  };

  const savePayrollSettings = async () => {
    try {
      await api.post("hrms/settings/payroll", {
        pay_cycle: payCycle,
        pay_day: payDay,
      });
      alert("Payroll settings saved!");
    } catch (err) {
      alert("Saved in sample mode (API not ready)");
    }
  };

  const saveCompanySettings = async () => {
    try {
      await api.post("hrms/settings/company", {
        name: companyName,
        address,
      });
      alert("Company profile saved!");
    } catch (err) {
      alert("Saved in sample mode (API not ready)");
    }
  };

  return (
    <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
      <div className="container py-4">

        {/* PAGE HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 className="fw-bold">Settings</h3>
            <p className="text-muted">
              Manage your organization and payroll settings.
            </p>
          </div>

          <button className="btn btn-outline-secondary">Back to Home</button>
        </div>

        {/* TABS */}
        <div className="mb-3">
          <div className="btn-group">
            <button
              className={`btn ${activeTab === "payroll" ? "btn-primary" : "btn-light"}`}
              onClick={() => setActiveTab("payroll")}
            >
              Payroll
            </button>

            <button
              className={`btn ${activeTab === "company" ? "btn-primary" : "btn-light"}`}
              onClick={() => setActiveTab("company")}
            >
              Company Profile
            </button>

            <button
              className={`btn ${activeTab === "integrations" ? "btn-primary" : "btn-light"}`}
              onClick={() => setActiveTab("integrations")}
            >
              Integrations
            </button>
          </div>
        </div>

        {/* CONTENT BOX */}
        <div className="bg-white border rounded shadow-sm p-4">

          {/* ===============================
              PAYROLL SETTINGS TAB
          =============================== */}
          {activeTab === "payroll" && (
            <>
              <h5 className="fw-bold">Payroll Settings</h5>
              <p className="text-muted mb-4">
                Configure default payroll parameters.
              </p>

              <div className="mb-3">
                <label className="form-label fw-semibold">Pay Cycle</label>
                <input
                  className="form-control bg-light"
                  value={payCycle}
                  onChange={(e) => setPayCycle(e.target.value)}
                />
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">Default Pay Day</label>
                <input
                  className="form-control bg-light"
                  value={payDay}
                  onChange={(e) => setPayDay(e.target.value)}
                />
              </div>

              <button
                className="btn btn-primary"
                onClick={savePayrollSettings}
              >
                Save Changes
              </button>
            </>
          )}

          {/* ===============================
              COMPANY PROFILE TAB
          =============================== */}
          {activeTab === "company" && (
            <>
              <h5 className="fw-bold">Company Profile</h5>
              <p className="text-muted mb-4">
                Update your company's information.
              </p>

              <div className="mb-3">
                <label className="form-label fw-semibold">Company Name</label>
                <input
                  className="form-control bg-light"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">Address</label>
                <input
                  className="form-control bg-light"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <button
                className="btn btn-primary"
                onClick={saveCompanySettings}
              >
                Save Changes
              </button>
            </>
          )}

          {/* ===============================
              INTEGRATIONS TAB
          =============================== */}
          {activeTab === "integrations" && (
            <>
              <h5 className="fw-bold">Integrations</h5>
              <p className="text-muted mb-2">
                Connect with other services.
              </p>

              <p className="text-muted">No integrations connected.</p>
            </>
          )}

        </div>
      </div>
    </div>
  );
}
